module.exports = __webpack_public_path__ + "img/resized-APP-0015-2.46f6dd0a.png";